import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.min.css";
import "./custom.css";
import "./responsive.css";
import Router from './router/NavRouter';
import { ToastContainer } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import React from 'react';
import { BaseUrl } from './helper/BaseUrl';
import SEO from './helper/SEO';

function App({initialData, initialSeo}) {
  const [seoData, setSeoData] = useState(null);
  const location = useLocation();
  
  useEffect(() => {
    if (typeof window !== "undefined") {
      const existingSource = sessionStorage.getItem("source_url");
      if (!existingSource) {
        const landingUrl = window.location.href;
        sessionStorage.setItem("source_url", landingUrl);
      }
    }
  }, []);


  const NormalizeTrailingSlash = () => {
  useEffect(() => {
      if (location.pathname !== '/' && location.pathname.endsWith('/')) {
        window.history.replaceState(
          null,
          '',
          location.pathname.slice(0, -1) + location.search + location.hash
        );
      }
    }, []);

    return null;
  };

  const Detailfetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/seo${location.pathname}`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.success === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setSeoData(result.data);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    Detailfetcher();
  }, [location.pathname])

  return (
    <div className="App">
      <SEO seoData={seoData} initialSeo={initialSeo}/>
      <NormalizeTrailingSlash/>
      <Router initialData={initialData}/>
      <ToastContainer/>
    </div>
  );
}

export default App;
